// React import
import React, { Fragment, useEffect, useState, useCallback } from 'react';
// Material import
import { styled } from "@mui/system";
import {Divider, Select, MenuItem, InputLabel,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
  } from "@mui/material";
import { CircularProgress } from "@mui/material";
// custom component import
import styles from "./DailyProductionInsight.module.css";
import CustomTooltip from "../../../utils/CustomTooltip";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    "&.MuiTableCell-head": {
        fontFamily: "Unilever Shilling",
        backgroundColor: "var(--primany-table-header-color)",
        color: "#fff",
        textAlign: "center",
        padding: "3px",
        fontSize: "11px",
        fontWeight: 600,
        outline: "1px solid #EAECF0",
        whiteSpace: "nowrap",
    },
    "&.MuiTableCell-body": {
        fontFamily: "Unilever Shilling",
        fontSize: "11px",
        fontWeight: 400,
        padding: "3px",
        color: "#2B2B2B",
        border: "1px solid #EAECF0",
        textAlign: "center",
        whiteSpace: "nowrap",
        // backgroundColor: value ? getCellBgColor(value, colname) : "#FFFFFF",
    },
}));

const StyledTableRow = styled(TableRow)({
    backgroundColor: "#FFFFFF !important"
});

const getBGColor = (value, col) => {
    if(['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].includes(col)){
        let val = typeof value === 'string' ?  parseFloat(value?.replace('%', '')) : value;
        if(val >= 76){
            return {
                backgroundColor: "#FF9998",
                border: "1px solid #FF9998",
                borderRadius: '4px',
                padding: '0px 5px'
            };
        } 
        if(val < 76 && val >= 26){
            return {
                backgroundColor: "#FFEC9A",
                border: "1px solid #FFEC9A",
                borderRadius: '4px',
                padding: '0px 5px'
            };
        }
        if(val < 26){
            return {
                backgroundColor: "#A3E1D2",
                border: "1px solid #A3E1D2",
                borderRadius: '4px',
                padding: '0px 5px'
            };
        }
    }else{
        return {
                backgroundColor: "#FFFFFF"
            };
    }
}
const ChangeSystemVsMMPlan =({data, loader})=> {
    const [selectedLine, setSelectedLine] = useState('All');
    const [selectedCascade, setSelectedCascade] = useState('All');
    const [tableData, setTableData] = useState([]);
    const [dbTableData, setDbTableData] = useState([]);
    const [lineList, setLineList] = useState([]);
    const [cascadeList, setCascadeLineList] = useState([]);
    const [tableColumns, setTableColumns] = useState([]);
   
    useEffect(() => {
        if(data?.length > 0){
            setTableData(data || []);        
            setDbTableData(data || []); //save for further filter.
            setLineList([...new Set(data?.map(itm => itm?.Line))]); //for Line dropdown option
            setCascadeLineList([...new Set(data?.map(itm => itm?.Cascade))]); //for Cascade dropdown option
            setTableColumns(Object.keys(data[0])?.filter(key => key !== 'Cascade'));
        }
    }, [data]);

    const lineHandleChange = useCallback ((e)=>{
        setSelectedLine((prev)=> e.target.value);
    }, []);
    const cascadeHandleChange = useCallback ((e)=>{
        setSelectedCascade((prev)=> e.target.value);
    }, []);
    useEffect(()=>{
        if(dbTableData?.length > 0){
            let tempTableData = [...dbTableData];
            if(selectedLine === 'All' && selectedCascade !== 'All'){
                // filter table data and set
                tempTableData = dbTableData?.filter(itm=>itm["Cascade"] === selectedCascade);
            }else if(selectedLine !== 'All' && selectedCascade === 'All'){
                // filter table data and set
                tempTableData = dbTableData?.filter(itm=>itm["Line"] === selectedLine);
            }else if(selectedLine !== 'All' && selectedCascade !== 'All'){
                // filter table data and set
                tempTableData = dbTableData?.filter(itm=>itm["Cascade"] === selectedCascade && itm["Line"] === selectedLine);
            }else{
                tempTableData = [...dbTableData];
            }
            setTableData(tempTableData);
        }
    }, [selectedLine, selectedCascade, dbTableData]);
	return(
		<Fragment>
            <div className={styles.adoptionDiv}>
                <div className={styles.planText}><span>Change % : system vs MM plan</span></div>
                <Divider className={styles.hr}/>
                {loader ? 
                <div className={styles.loaderContainer}><CircularProgress /></div> :
                <>
                    <div style={{display:'flex', flexDirection:'row', justifyContent:'flex-end'}}>
                        <div className={styles.menuItem}>
                            <InputLabel htmlFor="line" className={styles.label} style={{ color:'#4D4D4F' }}>Line</InputLabel>
                            <Select
                                id="line"
                                value={selectedLine}
                                onChange={lineHandleChange}
                                size="small"
                                className={styles.selectedOption}
                            >
                                <MenuItem className={styles.listItem} value="All">Select All</MenuItem>
                                {lineList.map((line) => (
                                    <MenuItem className={styles.listItem} key={line} value={line}>
                                        {line}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                        <div className={styles.menuItem}>
                            <InputLabel htmlFor="casecade" className={styles.label} style={{ color:'#4D4D4F' }}>Cascade</InputLabel>
                            <Select
                                id="casecade"
                                value={selectedCascade}
                                onChange={cascadeHandleChange}
                                size="small"
                                className={styles.selectedOption}
                            >
                                <MenuItem className={styles.listItem} value="All">Select All</MenuItem>
                                {cascadeList.map((line) => (
                                    <MenuItem className={styles.listItem} key={line} value={line}>
                                        {line}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                    </div>
                    <TableContainer className={styles.table} style={{ width: "100%", marginTop:"10px", height: "35vh"}}>
                        <Table size="small" stickyHeader>
                            {/* Main header row */}
                            <TableHead>
                                <TableRow>
                                    {tableColumns?.map((col, index) => {
                                        return (
                                            <StyledTableCell
                                                key={`h-${col}-${index}`}
                                            >
                                                <div className={styles.sortIcon}>
                                                    {col}
                                                </div>
                                            </StyledTableCell>
                                        );
                                    })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData?.length === 0 ?
                                (
                                    <StyledTableRow key={`r-0`}>
                                        <StyledTableCell 
                                            key={`c0`}
                                            colSpan={10}
                                        >
                                            Data not available...
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ) :
                                tableData.map((row, rowIndex) => (
                                    <StyledTableRow key={`r-${rowIndex}`}>
                                        {tableColumns?.map((col, colIdx) =>
                                            ["Format", "Line"]?.includes(col) ?
                                            <StyledTableCell 
                                                key={`c${rowIndex + colIdx}`} 
                                                className={styles.ellipsisText}
                                            >
                                                <CustomTooltip title={row[col]}>
                                                    <span>{row[col]}</span>
                                                </CustomTooltip>
                                            </StyledTableCell> : 
                                            <StyledTableCell 
                                                key={`c${rowIndex + colIdx}`}
                                            >
                                                <p style={getBGColor(row[col], col)}>{row[col]}</p>
                                            </StyledTableCell>
                                        )}
                                    </StyledTableRow>
                                )) }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <div className={styles.contractLegends}>
                        <div className={styles.contractLegendsDiv}>
                            <span className={styles.legends} style={{ backgroundColor: "#A3E1D2" }}></span>
                            <span>0 to 25</span>
                        </div>
                        <div className={styles.contractLegendsDiv}>
                            <span className={styles.legends} style={{ backgroundColor: "#FFEC9A" }}></span>
                            <span>26 to 75</span>
                        </div>
                        <div className={styles.contractLegendsDiv}>
                            <span className={styles.legends} style={{ backgroundColor: "#FF9998" }}></span>
                            <span>76 to 100</span>
                        </div>
                    </div>
                </>}
            </div>
		</Fragment>
	);
}

export default ChangeSystemVsMMPlan;